const palette = {
  background: {
    default: '#fff',
  },
  text: {
    primary: '#17252A',
    secondary: '#00698E',
  },
  primary: {
    light: '#17252A',
    main: '#17252A',
    dark: '#17252A',
    contrastText: '#fff',
  },
  secondary: {
    light: '#6affff',
    main: '#3AAFA9',
    dark: '#00a7bc',
    contrastText: '#fff',
  },
};

export default palette;
